var _path, _path2, _rect, _rect2, _path3, _rect3, _path4, _path5, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _path6, _path7, _path8;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMapBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 56,
    viewBox: "0 0 264 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E6DC",
    d: "M234.036-102.313l57.845 179.725L7.47 168.95-50.374-10.775z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.364 37.959L265.958-4.717l-1.669-5.188-101.543 32.682-29.758-92.456-6.376 2.052 29.757 92.456-26.144 8.415-24.526-76.204 17.896-23.696-5.432-2.584L60.64 7.262l-2.617.616L.176 18.108l-45.284-33.402-4.618 4.422 97.01 70.81-67.253 21.646 1.67 5.188 69.211-22.276 26.215 81.45 6.377-2.052-26.215-81.45 68.647-22.095 87.485 61.73 4.619-4.422-84.676-59.698zm-78.653 19.59l17.487-5.629-12.482-38.78-53.362 9.436 48.357 34.972zM65.73 9.961l12.844 39.906 45.274-14.572-23.085-71.722L65.731 9.962z",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 146.167,
    y: 13.52,
    width: 8.72,
    height: 16.747,
    rx: 2,
    transform: "rotate(72.16 146.167 13.52)",
    fill: "#D3D0CB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 136.643,
    y: -16.052,
    width: 26.705,
    height: 16.747,
    rx: 2,
    transform: "rotate(72.16 136.643 -16.052)",
    fill: "#D3D0CB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.645 54.958a2 2 0 011.292-2.517l22.624-7.282a2.002 2.002 0 011.804.297l12.748 9.443c1.308.97.972 3.012-.578 3.511l-31.422 10.113a2 2 0 01-2.517-1.29l-3.95-12.276z",
    fill: "#D3D0CB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 62.444,
    y: 64.508,
    width: 31.484,
    height: 16.895,
    rx: 2,
    transform: "rotate(-17.84 62.444 64.508)",
    fill: "#D3D0CB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-3.722 46.651a2 2 0 011.291-2.516l13.48-4.339a2 2 0 011.818.308l22.921 17.31c1.293.976.95 3.003-.593 3.5l-29.2 9.398a2 2 0 01-2.517-1.291l-7.2-22.37z",
    fill: "#D3D0CB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-35.03 24.112a2 2 0 011.29-2.517l13.498-4.344a2 2 0 011.795.29l29.124 21.323c1.434 1.05.89 3.308-.865 3.589l-35.336 5.66a2 2 0 01-2.22-1.361l-7.286-22.64zM96.576-22.277c.98-1.284 2.999-.937 3.493.6l16.916 52.559a2 2 0 01-1.291 2.516L84.431 43.461a2 2 0 01-2.517-1.291l-9.92-30.823a2 2 0 01.314-1.826l24.268-31.798z",
    fill: "#D3D0CB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 172.02,
    y: -15.443,
    width: 28.213,
    height: 16.843,
    rx: 2,
    transform: "rotate(72.16 172.02 -15.443)",
    fill: "#D3D0CB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 191.813,
    y: -21.814,
    width: 28.213,
    height: 16.843,
    rx: 2,
    transform: "rotate(72.16 191.813 -21.814)",
    fill: "#D3D0CB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 212.145,
    y: -28.357,
    width: 28.213,
    height: 16.843,
    rx: 2,
    transform: "rotate(72.16 212.145 -28.357)",
    fill: "#D3D0CB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 197.56,
    y: 20.77,
    width: 18.629,
    height: 14.174,
    rx: 2,
    transform: "rotate(72.16 197.56 20.77)",
    fill: "#D3D0CB"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 212.804,
    y: 15.96,
    width: 18.491,
    height: 12.652,
    rx: 2,
    transform: "rotate(72.16 212.804 15.96)",
    fill: "#D3D0CB"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 263.757,
    y: -0.439,
    width: 18.491,
    height: 50.607,
    rx: 2,
    transform: "rotate(72.16 263.757 -.439)",
    fill: "#D3D0CB"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 204.355,
    y: 41.881,
    width: 16.855,
    height: 14.174,
    rx: 2,
    transform: "rotate(72.16 204.355 41.88)",
    fill: "#D3D0CB"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 219.662,
    y: 37.268,
    width: 16.545,
    height: 12.652,
    rx: 2,
    transform: "rotate(72.16 219.662 37.268)",
    fill: "#D3D0CB"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 270.615,
    y: 20.869,
    width: 16.545,
    height: 24.331,
    rx: 2,
    transform: "rotate(72.16 270.615 20.869)",
    fill: "#D3D0CB"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 276.578,
    y: 39.397,
    width: 16.545,
    height: 24.331,
    rx: 2,
    transform: "rotate(72.16 276.578 39.397)",
    fill: "#D3D0CB"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 244.675,
    y: 29.217,
    width: 36.009,
    height: 23.357,
    rx: 2,
    transform: "rotate(72.16 244.675 29.217)",
    fill: "#BDDCFC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.574 17.884a2 2 0 012.25 1.357l9.039 28.083a2 2 0 01-1.291 2.516l-7.707 2.48a2 2 0 01-1.785-.282L19.83 27.273c-1.432-1.036-.916-3.284.825-3.59l32.919-5.799zM177.314 27.287a2 2 0 012.516 1.29l10.733 33.348a2 2 0 01-1.291 2.516l-7.335 2.361a1.999 1.999 0 01-1.78-.28l-35.345-25.426c-1.332-.958-1.007-3.024.555-3.527l31.947-10.282z",
    fill: "#BCD499"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M228.287 6.888L213.38-39.433l6.485-2.088L234.773 4.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-9.178.996C-21.431-5.991-29.841-16.342-33.98-23.852l17.687-8.317c3.204 5.814 9.92 13.985 19.177 19.264 9.007 5.136 19.722 7.239 32.322 2.755l.426-.152.437-.12c8.744-2.39 33.737-16.057 41.704-51.539l18.962 1.146C87.463-19.522 57.347.122 40.384 4.958 20.276 11.98 3.24 8.078-9.178.996z",
    fill: "#BDDCFC"
  })));
}

export default SvgIconMapBackground;